import { useState } from 'react';

import axios from 'axios';

export function useFetch() {
  const [fetchData, setFetchData] = useState(null);
  const [postFormData, setPostFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  async function fetchUrl(url) {
    setLoading(true);
    try {
      const response = await axios.get(url);
      setFetchData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }

  async function postFormDataUrl({ url, formData, headers }) {
    setLoading(true);
    try {
      const response = await axios.post(url, formData, {
        headers,
      });
      setPostFormData(response.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }

  return { fetchData, postFormData, loading, error, fetchUrl, postFormDataUrl };
}
